import { Button, Chip, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, TextField } from '@mui/material';
import React, { memo, useMemo, useState } from "react";
import { map, get } from "lodash";
import { SelectedTextEditor } from "components/UI";
import TextEditor from "components/TextEditor";
import Acent from "components/Acent";
import { Col, Dropdown, Row } from "antd";
import { Delete } from '@mui/icons-material';
import { Autocomplete } from '@mui/material';
import SentryWrap from "components/Sentry";
import MatchMakingImage from "components/Image/MatchMakingImage";
import styled from "styled-components";
import MatchMakingAudio from "components/Image/MatchMakingAudio";
import { DeleteModal } from "components/Dialog";
import { useTabletDetection } from 'containers/chat/hooks';

const AssignmentDescription = styled.span`
  color: #6c757d;
  display: block;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
`;

const Detail = styled(AssignmentDescription)`
  color: #495057;
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
`;

const FILL_BLANK_OVERLAY_Z = 1550;

const AssignmentFormFillInBlanksComp = ({
  SelectAnswerDropDown,
  disabled,
  showImagePicker,
  embedInMuiModal,
  ...props
}) => {
  const [hasChanged, setHasChanged] = useState(false);
  const [checkedRadio, setCheckedRadio] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const isTablate = useTabletDetection();
  const { answerRefs, optionRefs } = props?.refs;
  const { index, question, questions, optionStates, isEditing } = props?.states;
  const {
    onAddOption,
    onchangeOptionFilling,
    onDeleteOption,
    handleInputChange,
    onUpdateAnswer,
    getInputValue,
    makeAnswerSubmitHandler,
    handlePictureFilling,
    toggleDropdown,
    toggleEditor,
    setButtonDisabled,
    onChangeQuestionData,
    onMediaUploaded,
  } = props?.funcObj;

  const questionType = useMemo(() => {
    if (question) {
      return question?.type;
    }
  }, [question]);

  const deleteCustomAssignment = async () => {
    onChangeQuestionData(checkedRadio, "fillingType", index);
    setDeleteModal(false);
    setHasChanged(false);
  };


  return (
    <SentryWrap>
      <DeleteModal
        message={`Are you sure you want to change the media type?.`}
        deleteToggle={deleteModal}
        setDeleteToggle={setDeleteModal}
        onDelete={deleteCustomAssignment}
        buttonTitle={`yes`}
      />
       <Detail>{`Response type`}</Detail>
      <FormControl>
        <RadioGroup
          row
          onChange={(e) => {
            onChangeQuestionData(e.target.value, "response_type", index);
          }}
          aria-labelledby="category-type-radio-buttons-group-label"
          name="category-type-radio-buttons-group-label"
          style={{ gap: "20px" }}
          defaultValue={"None"}
          value={question.response_type || 'dropdown'}
        >
          <FormControlLabel
            disabled={disabled}
            value="dropdown"
            control={<Radio />}
            label="Dropdown"
            style={{ marginRight: "10px" }}
          />
          <FormControlLabel
            disabled={disabled}
            value="input"
            control={<Radio />}
            label="Text Input"
            style={{ marginRight: "10px" }}
          />
        </RadioGroup>
      </FormControl>
      <Detail>{`Attach Media (Audio, Image)`}</Detail>
      <FormControl>
        <RadioGroup
          row
          onChange={(e) => {
            const filteredOptions = question.options?.filter((opt) => opt.trim() !== ""); // Remove empty strings
            if (isEditing) {
              if (filteredOptions?.length > 0) {
                setCheckedRadio(e.target.value);
                setDeleteModal(true);
              } else {
                onChangeQuestionData(e.target.value, "fillingType", index);
              }
            } else {
              if (hasChanged) {
                setCheckedRadio(e.target.value);
                setDeleteModal(true);
              } else {
                onChangeQuestionData(e.target.value, "fillingType", index);
              }
            }
          }}
          aria-labelledby="category-type-radio-buttons-group-label"
          name="category-type-radio-buttons-group-label"
          style={{ gap: "20px" }}
          defaultValue={"None"}
          value={question.fillingType}
        >
          <FormControlLabel
            disabled={disabled}
            value="None"
            control={<Radio />}
            label="None"
            style={{ marginRight: "10px" }}
          />
          <FormControlLabel
            disabled={disabled}
            value="Audio"
            control={<Radio />}
            label="Audio"
            style={{ marginRight: "10px" }}
          />
          <FormControlLabel
            disabled={disabled}
            value="Image"
            control={<Radio />}
            label="Image"
            style={{ marginRight: "10px" }}
          />
        </RadioGroup>
      </FormControl>
      {map(get(question, "options", [""]), (option, optId) => (
        <Row
          key={optId}
          style={{
            marginBottom: "8px",
            alignItems: "flex-start",
            gap: "5px",
            flexWrap: "nowrap",
            flexDirection: "column",
          }}
        >
          <Col style={{ width: "100%" }}>
            <Row justify={"end"}>
              {get(question, "options", []).length > 1 && (
                <Col
                  className="delete-button"
                  span={2}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <IconButton
                    onClick={() => {
                      onDeleteOption(index, optId);
                    }}
                    style={{ padding: 0, marginBottom: 10 }}
                    disabled={disabled}
                  >
                    <Delete color="secondary" />
                  </IconButton>
                </Col>
              )}
              {/* <Acent
                inputRef={optionRefs.current[`${index}-${optId}`]}
                setValue={(v) => onchangeOptionFilling(index, optId, v)}
                style={{
                  marginBottom: 5,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              /> */}
            </Row>
            <div>
              <label style={{ marginBottom: 0 , fontSize: 12, fontWeight: 400 }}>Question*</label>
              <TextEditor
                handleChange={(value) => {
                  setHasChanged(true);
                  onchangeOptionFilling(index, optId, value);
                }}
                value={option || ''}
                placeholder="Type your question here..."
                autoFocus={false}
                disabled={disabled}
                containerClassName='customFillBlanktextfield'
              />
            </div>
            <SelectedTextEditor
              text={option}
              submitHandler={(getAllText, highlightWord) =>
                makeAnswerSubmitHandler(index, optId, getAllText, highlightWord)
              }
              onClose={() => toggleEditor(optId, false, questionType, index)}
              open={
                (optionStates?.[optId]?.editorOpen &&
                  optionStates?.[optId].type === questionType &&
                  optionStates?.[optId]?.questionIndex === index) ||
                false
              }
              highlightsWord={
                questions[index].highlightWords &&
                questions[index].highlightWords[optId]
              }
              answerSelected={
                questions[index].answerSelected &&
                questions[index].answerSelected[optId]
              }
              from="assignment"
              stripPunctuation={true}
              drawerZIndex={embedInMuiModal ? FILL_BLANK_OVERLAY_Z : undefined}
            />
          </Col>
          <Col style={{ width: "100%" }}>
            <Row justify={"end"}>
              <Dropdown
                disabled={!option?.length || disabled}
                menu={SelectAnswerDropDown({
                  optionText: option,
                  questionIndex: index,
                  optId,
                  questionType
                })}
                open={
                  (optionStates?.[optId]?.dropdownOpen &&
                    optionStates?.[optId]?.type === questionType &&
                    optionStates?.[optId]?.questionIndex === index) ||
                  false
                }
                onOpenChange={(flag) =>
                  toggleDropdown(optId, flag, questionType, index)
                }
                trigger={["click", "touch"]}
                getPopupContainer={
                  embedInMuiModal
                    ? () => document.body
                    : (triggerNode) => triggerNode.parentNode
                }
                overlayStyle={
                  embedInMuiModal ? { zIndex: FILL_BLANK_OVERLAY_Z } : undefined
                }
              >
                <Button
                  disabled={option?.length === 0 || !option}
                  variant="contained"
                  color="primary"
                  style={{ marginBottom: 16 }}
                >
                  Select Answer
                </Button>
              </Dropdown>
            </Row>
            <Acent
              inputRef={answerRefs.current[`${index}-${optId}`]}
              setValue={(v) => handleInputChange(index, optId, v)}
              style={{
                marginBottom: 5,
                display: "flex",
                justifyContent: "flex-end",
              }}
            />
            {/* Autocomplete for Answer Field */}
            <Row justify="start" style={{ marginBottom: 20 }}>
              <Col xs={24} lg={24}>
                <Autocomplete
                  multiple
                  freeSolo
                  id={`autocomplete-answer-${index}-${optId}`}
                  slotProps={
                    embedInMuiModal
                      ? {
                          popper: {
                            sx: { zIndex: FILL_BLANK_OVERLAY_Z },
                          },
                        }
                      : undefined
                  }
                  options={[]}
                  value={
                    get(question, `answerSelected[${optId}]`, [])
                      ? get(question, `answerSelected[${optId}]`, [])?.map(
                          (item) => {
                            if (item?.type === "highlight") {
                              return `${item.text}|||${item.id}`;
                            }
                            return item?.text || "";
                          }
                        )
                      : ""
                  }
                  style={{ width: "100%" }}
                  onChange={(event, values) => {
                    const currentAnswers = get(question, `answerSelected[${optId}]`, []) || [];
                    const selectedHighlightIds = new Set();
                    const selectedCustomTexts = new Set();
                    const result = [];
                    
                    values.forEach((value) => {
                      if (!value || !value.trim()) return;
                      
                      if (value.includes("|||")) {
                        const [text, id] = value.split("|||");
                        const highlightId = id ? parseFloat(id) : null;
                        if (highlightId) {
                          selectedHighlightIds.add(highlightId);
                        }
                      } else {
                        const normalizedText = value.toLowerCase().trim();
                        selectedCustomTexts.add(normalizedText);
                      }
                    });
                    
                    currentAnswers.forEach(item => {
                      if (item.type === "highlight") {
                        if (selectedHighlightIds.has(item.id)) {
                          result.push({
                            start: item.start ?? null,
                            end: item.end ?? null,
                            text: item.text,
                            id: item.id,
                            type: "highlight",
                          });
                        }
                      } else {
                        const normalizedText = item?.text?.toLowerCase()?.trim();
                        if (normalizedText && selectedCustomTexts.has(normalizedText)) {
                          if (!result.some(r => r.type === "custom" && r.text?.toLowerCase()?.trim() === normalizedText)) {
                            result.push({
                              start: item.start ?? null,
                              end: item.end ?? null,
                              text: item.text,
                              id: item.id,
                              type: "custom",
                            });
                          }
                        }
                      }
                    });
                    
                    values.forEach((value) => {
                      if (!value || !value.trim()) return;
                      
                      if (!value.includes("|||")) {
                        const normalizedValue = value.toLowerCase().trim();
                        const hasExistingItem = currentAnswers.some(
                          item => item?.text?.toLowerCase()?.trim() === normalizedValue
                        );
                        
                        if (!hasExistingItem) {
                          const hasHighlight = currentAnswers.some(
                            item => item?.type === "highlight" && item?.text?.toLowerCase()?.trim() === normalizedValue
                          );
                          
                          if (!hasHighlight && !result.some(r => r.type === "custom" && r.text?.toLowerCase()?.trim() === normalizedValue)) {
                            result.push({
                              start: null,
                              end: null,
                              text: value.trim(),
                              id: Date.now() + Math.random(),
                              type: "custom",
                            });
                          }
                        }
                      }
                    });
                    onUpdateAnswer(index, optId, result);
                  }}
                  onKeyDown={(event) => {
                    // Stop event bubbling and prevent default backspace behavior
                    if (event.key === "Backspace") {
                      event.preventDefault();
                      event.stopPropagation();
                      return false;
                    }
                  }}
                  disableCloseOnSelect
                  blurOnSelect={false}
                  renderTags={(value, getTagProps) => {
                    return value.map((option, tagIndex) => {
                      const displayText = option.includes("|||") 
                        ? option.split("|||")[0] 
                        : option;
                      return (
                        <Chip
                          key={option}
                          label={
                            displayText?.length > 50
                              ? displayText.slice(0, 50) + "..."
                              : displayText
                          }
                          {...getTagProps({ index: tagIndex })}
                          className="custom-chip"
                          data-manual={"true"}
                          style={{ margin: "0 5px 5px 5px" }}
                        />
                      );
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      type="text"
                      inputRef={(ref) =>
                        (answerRefs.current[`${index}-${optId}`] = ref)
                      }
                      label="Answers"
                      placeholder="Enter or select answers"
                      disabled={disabled}
                      inputProps={{
                        ...params.inputProps,
                        value: getInputValue(index, optId),
                        onChange: (e) => {
                          const value = e.target.value;
                          handleInputChange(index, optId, value);
                        },

                        onKeyDown: (e) => {
                          if (e.key === "Backspace") {
                            e.stopPropagation();
                            if (!getInputValue(index, optId)) {
                              e.preventDefault();
                            }
                            return;
                          }

                          if (
                            e.key === "Enter" &&
                            getInputValue(index, optId).trim()
                          ) {
                            const currentAnswers =
                              get(question, `answerSelected[${optId}]`, []) ||
                              [];
                            const inputValue = getInputValue(index, optId).trim();
                            const normalizedInput = inputValue.toLowerCase();
                            
                            const existingCustomItem = currentAnswers.find(
                              (answer) => answer.type === "custom" && answer.text?.toLowerCase()?.trim() === normalizedInput
                            );
                            
                            const hasHighlight = currentAnswers.some(
                              (answer) => answer.type === "highlight" && answer.text?.toLowerCase()?.trim() === normalizedInput
                            );
                            
                            if (!existingCustomItem && !hasHighlight) {
                              const normalizedCurrentAnswers = currentAnswers.map(item => ({
                                start: item.start ?? null,
                                end: item.end ?? null,
                                text: item.text,
                                id: item.id,
                                type: item.type || "custom",
                              }));
                              
                              const newAnswer = {
                                start: null,
                                end: null,
                                text: inputValue,
                                id: Date.now() + Math.random(),
                                type: "custom",
                              };
                              
                              onUpdateAnswer(index, optId, [
                                ...normalizedCurrentAnswers,
                                newAnswer,
                              ]);
                            }
                            handleInputChange(index, optId, "");
                          }
                        },
                      }}
                    />
                  )}
                />
              </Col>
            </Row>
            {/* Add Image for fillingImage type */}
            {questionType === "fillingImage" || question.fillingType === "Image" && (
              <MatchMakingImage
                source={
                  question?.filling_image && question?.filling_image[optId]?.url
                }
                handlePicture={(v) => {
                  setHasChanged(true);
                  handlePictureFilling(index, optId, v)
                }}
                // style={{marginTop: question?.filling_image && question?.filling_image[optId]?.url ? "50px" : ""}}
                style={{marginTop: question?.filling_image && question?.filling_image[optId]?.url ? (window.innerWidth >= 1024 ? "130px" : "85px") : "" }}
                // imageClassName="assignment-image"
                imageClassName={`assignment-image ${isTablate ? "assignmentTabImg" : ""}`} 
                containerClassName="assignment-ebook"
                setButtonDisabled={(value) => setButtonDisabled(value)}
                showImagePicker={showImagePicker}
              />
            )}
            {question.fillingType === "Audio" && (
              <MatchMakingAudio
                source={
                  question?.filling_image && question?.filling_image[optId]?.url
                }
                handlePicture={(v) => {
                  setHasChanged(true);
                  handlePictureFilling(index, optId, v)
                }}
                onMediaUploaded={onMediaUploaded}
                setButtonDisabled={(value) => setButtonDisabled(value)}
              />
            )}
          </Col>
        </Row>
      ))}
      <Button
        variant="contained"
        color="primary"
        style={{ marginBottom: 16 }}
        className={
          question.fillingType === "Audio"
            ? "audioFillBlank"
            : questionType === "fillingImage" || question.fillingType === "Image"
            ? "imageFillBlank"
            : ""
        }
        disabled={disabled}
        onClick={() => onAddOption(index)}
      >
        Add Sub Question
      </Button>
    </SentryWrap>
  );
};

export default memo(AssignmentFormFillInBlanksComp);
